import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'StatusBanner';
const surveyName = 'HotelRecommendationNeeded';

const telemetry = createTelemetryObject({
  actions: {
    trackError: (error: Error | unknown) => ({
      category,
      action: 'updateInviteePropertyNeedHotelRecommendations',
      actionType: 'error',
      extraInfo: { error },
    }),
    /**
     * Events without a Firebase document only: the server answered but declined to store the
     * preference. The guest sees the same outcome as a stored answer, so this is not an error and
     * stays out of `trackError`; it is recorded here and nowhere else.
     */
    answerNotAccepted: (answerValue: string) => ({
      category,
      action: 'NeedHotelRecommendationsNotAccepted',
      label: `${surveyName}CTA`,
      extraInfo: {
        surveyName,
        answerValue,
      },
    }),
    answerClicked: (answerValue: string) => ({
      category,
      action: 'TravelButtonInteracted',
      label: `${surveyName}CTA`,
      extraInfo: {
        surveyName,
        answerValue,
      },
    }),
    pageViewed: () => ({
      category,
      action: 'PageViewed',
      page: 'accommodationsPage',
      extraInfo: {
        surveyName,
        name: 'guest.wedding.accommodations',
      },
    }),
  },
});

export const { useTelemetry: useStatusBannerTelemetry, TelemetryProvider: StatusBannerTelemetryProvider } = createTelemetry(telemetry);
